<template>
    <div class="content">
        <iframe width="100%" height="100%" :src='myURL' style="border: 0;height: 100%;"></iframe>
    </div>
</template>
<script>
export default {
    data(){
        return{
            myURL:'./monitor/view/monitorPro.html'
        }
    },
    mounted(){
        var that = this;
        window.addEventListener('message', function(e){
            if(e.data.projectId){
                var opt = e.data;
                let routeUrl = that.$router.resolve({
                    name: "monitoring",
                    // params: {'id': opt.projectId,'type':opt.machType,'sn':opt.sn,'channel':opt.channelNo}
                });
                window.open(routeUrl .href, '_blank');
            }
        })
    },
    methods:{
        
    }
}
</script>
<style scoped>
    .content{
        height: 100%;
        width: 100%;
        position: relative;
        background: #fff;
        padding: 0;
    }
</style>